import React, { useState, useEffect } from 'react'
import { Paper, Divider, Card } from '@mui/material'
import api from '../../API/api';




const Recruiters = () => {

    const [recruiter, setRecruiter] = useState();

    useEffect(() => {
        getRecruiter()
    }, []);

    const getRecruiter = () => {
        api.getRecruiter().then((res) => {
            // console.log(res);
            setRecruiter(res.data.recruiter)
        })
            .catch((err) => {
                // console.log(err.response);
            })
    }


    return (
        <>
            <div className='my-2'>
                <Paper elevation={3}>
                    <div className='p-5'>

                        <div className="text-center">
                            <h2> Top Recruiters </h2>
                        </div>
                        <div className='text-center pb-4'>
                            <i>PEWS Group of Institutions takes immense pride in its consistent success in attracting a growing number of esteemed organizations each year. Our strong emphasis on academic excellence, combined with a holistic approach to student development, has led to fruitful collaborations with top recruiters. Here are some of the leading organizations that regularly recruit our talented graduates</i>
                        </div>

                        <div className="recruitment-box p-4">

                            <div className="row justify-content-center">

                                {recruiter && recruiter.map((r) => (
                                    <>
                                        {r.status == 1 &&
                                            <div className="col-4 col-md-1 m-1 d-flex align-items-center rec-box">
                                                <img src={`${process.env.REACT_APP_BACKEND}assets/recruiter/${r.logo}`} alt="affi" className='col-12' />
                                            </div>
                                        }

                                    </>
                                ))
                                }


                                {/* <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/3.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/4.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/5.png" al ct="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/6.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/7.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/2.jpg" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/3.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/4.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/5.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/6.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/7.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/2.jpg" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/3.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/4.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/5.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/6.png" alt="affi" className='col-12' />
                                </div>
                                <div className="col-4 col-md-1 d-flex align-items-center rec-box">
                                    <img src="assets/affiliation/7.png" alt="affi" className='col-12' />
                                </div> */}

                            </div>


                        </div>


                    </div>
                </Paper>
            </div>

        </>
    )
}

export default Recruiters;